import './index.css';

const FAQs = () => {
  return (
    <div className="faqs-container w-full h-full">
      <div className="bg-[#1c293a] text-white text-3xl text-center py-12">
        <div className="px-4">FREQUENTLY ASKED QUESTIONS</div>
      </div>
      <div className="max-w-2xl mx-auto py-4 px-8 flex flex-col gap-4">
        <div className="bg-[#222f4094] text-white p-6">
          <div className='text-xl'>QUESTION 1</div>
          <div>LOREM IPSUM LOREM IPSUM  LOREM IPSUM  LOREM IPSUM  LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM </div>
        </div>
        <div className="bg-[#222f4094] text-white p-6">
          <div className='text-xl'>QUESTION 2</div>
          <div>LOREM IPSUM LOREM IPSUM  LOREM IPSUM  LOREM IPSUM  LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM </div>
        </div>
        <div className="bg-[#222f4094] text-white p-6">
          <div className='text-xl'>QUESTION 2</div>
          <div>LOREM IPSUM LOREM IPSUM  LOREM IPSUM  LOREM IPSUM  LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM </div>
        </div>
      </div>
    </div>
  )
};


export default FAQs;